exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Herr+Von+Muellerhoff&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Yellowtail&display=swap);", ""]);

// module
exports.push([module.id, ".signature-container .printed[data-v-23e8455b] {\n  margin-bottom: 20px;\n  font-size: 1.2em;\n  font-weight: bold;\n}\n.signature-container .signature[data-v-23e8455b] {\n  padding: 0px 15px 5px 15px;\n  font-size: 40pt;\n  font-family: \"Yellowtail\", cursive;\n}\n.signature-container .meta[data-v-23e8455b] {\n  margin-top: 25px;\n}", ""]);

// exports
